module.exports = __webpack_public_path__ + "static/media/tn-mpants-knee-open.0defe3ed.svg";